import {
    DWT_PAYLOADS_DEFAULT_LOOKBACK_DAYS,
    DWT_PAYLOADS_END_DATE_ELEMENT_ID,
    DWT_PAYLOADS_START_DATE_ELEMENT_ID,
} from '../dwt-payloads.constants';
import {
    localCalendarDateOnly,
    localCalendarDateOnlyDaysAgo,
} from './local-calendar-date-only.util';

/**
 * Inclusive last-N-days window for the DWT start/end date inputs (HTML `YYYY-MM-DD`).
 */
export function getDwtPayloadsDefaultDateRange(now: Date = new Date()): {
    startDate: string;
    endDate: string;
} {
    return {
        startDate: localCalendarDateOnlyDaysAgo(DWT_PAYLOADS_DEFAULT_LOOKBACK_DAYS - 1, now),
        endDate: localCalendarDateOnly(now),
    };
}

/** Prefills start/end date inputs when the DWT target is rendered. */
export function getDwtPayloadsDateFieldRendererDefaults(
    now: Date = new Date()
): Readonly<Record<string, string>> {
    const range = getDwtPayloadsDefaultDateRange(now);
    return {
        [DWT_PAYLOADS_START_DATE_ELEMENT_ID]: range.startDate,
        [DWT_PAYLOADS_END_DATE_ELEMENT_ID]: range.endDate,
    };
}
